<template>
    <div class="video-player">
        <div :id="id" ref="player" class="video"></div>
    </div>
</template>

<script>


    export default {
        props: {
          url: {
            type: String,
            default: ''
          },
          id: {
            type: String,
            default: ''
          },
          config: {
            type: Object,
            default: () => {
                return {}
            },
          }
        },
        methods:{
            playVideo (video_url) {
                var image = video_url.replace(/(.mp4|.m3u8)$/, '.jpg');
                // console.log(video_url, image);
                var defaultConfig = {
                    width: '90%',
                    height: 500,
                    stretching: "uniform",
                    file: video_url,
                    image,
                    autostart: false,
                    marquee:{show : false ,text:'中公网校',fontSize:20,color:'#990033'},
                    primary: "flash",
                    repeat: false,
                    volume: 100,
                    controls: true,
                    controlbar: {
                        barLogo: false, // 进度条上的logo显示与否,默认true

                    },
                    ak: '77f99df9002b4bb8be40288a9ca80e6b'
                };
                var config = { ...defaultConfig, ...this.config };
                var player = cyberplayer(this.id).setup(config);
            },

        },
        mounted () {
            this.playVideo(this.url);
        }
    }
</script>
<style scoped>
  .video-player {
    width: 100%;
  }
</style>
<style>
</style>



// WEBPACK FOOTER //
// src/components/video-player/index.vue